import "./templatesTab.scss";

import { map } from "lodash";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { Fragment, PureComponent } from "react";

import FormButton from "../../components/form/FormButton";
import ModalField from "../../components/modal/ModalField";
import ModalGroup from "../../components/modal/ModalGroup";
import { withModalResizeContext } from "../../components/modal/ModalResizeContext";
import ModalRow from "../../components/modal/ModalRow";
import PubSubTopics from "../../constants/pubSubTopics";
import dialogs from "../../dialogs";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";

const renderTemplateGroup = (templateDetails, onExportClick, onDeleteClick) => {
  const name = templateDetails.label;
  const category = templateDetails.category ? templateDetails.category : "Custom";
  const description = templateDetails.description;
  const creator = templateDetails.creator ? templateDetails.creator : "Anonymous";
  const exportButton = (
    <FormButton linkStyle={true} label="Export" onClick={() => onExportClick(name)} style={{ marginRight: "10px" }} />
  );
  const deleteButton = <FormButton linkStyle={true} label="Delete" onClick={() => onDeleteClick(name)} />;

  return (
    <ModalGroup key={name}>
      <ModalRow>
        <ModalField>
          <div className="templateInfoRow">
            <div className="category">{category}</div>
            <div className="templateName">{name}</div>
            {exportButton}
            {deleteButton}
          </div>
        </ModalField>
      </ModalRow>
      <ModalRow>
        <ModalField>
          <div className="templateCreator">
            <div className="templateDescription">Created by: {creator}</div>
          </div>
        </ModalField>
      </ModalRow>
      {description ? (
        <ModalRow>
          <ModalField>
            <div className="templateInfoRow">
              <div className="templateDescription">{description}</div>
            </div>
          </ModalField>
        </ModalRow>
      ) : null}
    </ModalGroup>
  );
};

class PreferencesTemplatesTab extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      customTemplates: null
    };
    this.onTemplateDataReceived = this.onTemplateDataReceived.bind(this);
    this.onImportClick = this.onImportClick.bind(this);
    this.onExportClick = this.onExportClick.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  componentDidMount() {
    this._pubSubDataReceivedToken = PubSub.subscribe(
      PubSubTopics.customTemplateIndexReceived,
      this.onTemplateDataReceived
    );
    this.requestDataRefresh();
  }

  componentDidUpdate() {
    this.props.triggerResize();
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubDataReceivedToken);
  }

  requestDataRefresh() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.REQUEST_CUSTOM_TEMPLATE_INDEX
    });
  }

  onTemplateDataReceived(msg, data) {
    this.setState({
      customTemplates: data
    });
  }

  onImportClick() {
    const data = {
      msg: nativeCommsBroadcastMessageTypes.IMPORT_CUSTOM_TEMPLATE
    };
    PubSub.publish(PubSubTopics.sendNativeMessage, data);
  }

  onExportClick(name) {
    const data = {
      msg: nativeCommsBroadcastMessageTypes.EXPORT_CUSTOM_TEMPLATE,
      name
    };
    PubSub.publish(PubSubTopics.sendNativeMessage, data);
  }

  onDeleteClick(name) {
    const alertMsg = `Are you sure you want to delete custom template ${name}?`;

    dialogs.okCancelPrompt(alertMsg, result => {
      if (result) {
        const data = {
          msg: nativeCommsBroadcastMessageTypes.DELETE_CUSTOM_TEMPLATE,
          name
        };
        PubSub.publish(PubSubTopics.sendNativeMessage, data);
      }
    });
  }

  render() {
    const msg = !this.state.customTemplates
      ? "Loading custom templates..."
      : this.state.customTemplates.length === 0
        ? "You have no custom templates"
        : null;

    let child = null;

    if (msg) {
      child = <div className="templatesTabTemplateMessage">{msg}</div>;
    } else {
      child = map(this.state.customTemplates, templateDetails =>
        renderTemplateGroup(templateDetails, this.onExportClick, this.onDeleteClick)
      );
    }

    return (
      <Fragment>
        <div className="templatesTabImportButton">
          <FormButton label="Import..." linkStyle={true} rightAlign={true} onClick={this.onImportClick} />
        </div>
        <div className="templatesTabTemplateList">{child}</div>
      </Fragment>
    );
  }
}

PreferencesTemplatesTab.propTypes = {
  // from withModalResizeContext
  triggerResize: PropTypes.func
};

export default withModalResizeContext(PreferencesTemplatesTab);
